module.exports = __webpack_public_path__ + "static/media/svg-6.b2059b42.svg";